import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'footer-component',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public environment = environment;
  public companyName: string = environment.company;
  protected mobileScreen:boolean = false;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    event.target.innerWidth <=768 ? this.mobileScreen = true : this.mobileScreen = false
    // this.width = event.target.innerWidth;
  }
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    if(isPlatformBrowser(this.platformId) && window.innerWidth<=768) this.mobileScreen = true;
  }
}
